module.exports = "<Button\n  type=\"primary\"\n  size=\"medium\"\n  text=\"Add\"\n  icon=\"add\"\n/>\n"